export type T_PortfolioAllocationBreakdown = {
  allocationBase: number;
  cashAllocationBalance: number;
  marginDebtBalance: number;
};

export function getSignedLiabilityBalance(liabilityBalance?: number): number {
  if (liabilityBalance === undefined) {
    return 0;
  }

  return liabilityBalance > 0 ? -liabilityBalance : liabilityBalance;
}

export function getLiabilityBalanceMagnitude(
  liabilityBalance?: number,
): number {
  return Math.abs(getSignedLiabilityBalance(liabilityBalance));
}

export function getNetCashBalance({
  cashBalance,
  liabilityBalance,
}: {
  cashBalance: number;
  liabilityBalance?: number;
}): number {
  return cashBalance + getSignedLiabilityBalance(liabilityBalance);
}

export function getPortfolioAllocationBreakdown({
  cashBalance,
  holdingsValue,
  liabilityBalance,
}: {
  cashBalance: number;
  holdingsValue: number;
  liabilityBalance?: number;
}): T_PortfolioAllocationBreakdown {
  const signedCashLiabilityBalance =
    liabilityBalance === undefined && cashBalance < 0
      ? Math.abs(cashBalance)
      : 0;
  const cashAllocationBalance = cashBalance > 0 ? cashBalance : 0;
  const marginDebtBalance =
    getLiabilityBalanceMagnitude(liabilityBalance) + signedCashLiabilityBalance;

  return {
    allocationBase: holdingsValue + cashAllocationBalance,
    cashAllocationBalance,
    marginDebtBalance,
  };
}

export function getPortfolioAllocationPercent({
  allocationBase,
  value,
}: {
  allocationBase: number;
  value: number;
}): number {
  return allocationBase > 0 ? (value / allocationBase) * 100 : 0;
}
